import { defineComponent as S, useSlots as b, computed as l, openBlock as u, createBlock as d, unref as r, normalizeClass as k, normalizeStyle as N, withCtx as m, renderSlot as h, createCommentVNode as f, createTextVNode as B, toDisplayString as A, h as c } from "vue";
import T from "./highrise.es308.js";
import { NAvatar as j } from "naive-ui";
import { getInitials as x } from "./highrise.es309.js";
import { JSONtoNaiveVars as F } from "./highrise.es266.js";
import "./highrise.es53.js";
import { getColorFromString as I } from "./highrise.es310.js";
import { avatarTextSizes as V, getSizeStyles as M } from "./highrise.es311.js";
import { validateSize as O, fallbackSize as g } from "./highrise.es312.js";
import { COMPONENT_NAME as $ } from "./highrise.es166.js";
import E from "./highrise.es153.js";
/* empty css               */
const R = S({
  name: $.AVATAR,
  inheritAttrs: !0
}), X = /* @__PURE__ */ S({
  ...R,
  props: {
    size: {
      type: String,
      default: "xs",
      validator: O
    },
    objectFit: {
      type: String,
      default: "fill"
    },
    round: {
      type: Boolean,
      default: !0
    },
    src: {
      type: String,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    preferredInitialsBgColor: {
      type: String
    }
  },
  setup(e) {
    const a = e, o = b(), z = l(() => ({
      [`hr-avatar-${g(a.size)}`]: !0
    })), v = l(() => {
      let t = V[g(a.size)];
      return a.round && (t = {
        ...t,
        borderRadius: "50%"
      }), F(t);
    }), y = l(() => {
      var n, i;
      const t = a.name || ((i = (n = o.default) == null ? void 0 : n.call(o)[0]) == null ? void 0 : i.children) || "";
      if (t)
        return I(t.toString());
    }), C = () => c("div", { class: "flex margin-auto " }, [c(T, { class: "hr-avatar" })]), p = l(
      () => ({
        "2xl": "4xl",
        xl: "4xl",
        lg: "4xl",
        md: "4xl",
        sm: "xs",
        xs: "2xs",
        "2xs": "4xs",
        "3xs": "4xs"
      })[a.size ?? "xs"]
    );
    return (t, n) => (u(), d(r(j), {
      class: k(z.value),
      style: N({
        backgroundColor: e.preferredInitialsBgColor ? e.preferredInitialsBgColor : y.value,
        ...v.value
      }),
      round: e.round,
      src: e.src ?? null,
      size: r(M)(e.size),
      "object-fit": e.objectFit,
      "render-fallback": C
    }, {
      default: m(() => {
        var i, s;
        return [
          (i = r(o)) != null && i.default && !e.name ? h(t.$slots, "default", { key: 0 }) : f("", !0),
          e.name && !((s = r(o)) != null && s.default) ? (u(), d(r(E), {
            key: 1,
            size: p.value
          }, {
            default: m(() => [
              B(A(e.size === "3xs" ? r(x)(e.name, 1) : r(x)(e.name)), 1)
            ]),
            _: 1
          }, 8, ["size"])) : f("", !0)
        ];
      }),
      _: 3
    }, 8, ["class", "style", "round", "src", "size", "object-fit"]));
  }
});
export {
  X as default
};
//# sourceMappingURL=highrise.es79.js.map
